import { LayoutDashboard, ArrowRightLeft, CreditCard, Stethoscope, GraduationCap, Upload, Newspaper, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const items = [
  { id: "overview", label: "Visão Geral", icon: LayoutDashboard },
  { id: "transactions", label: "Transações", icon: ArrowRightLeft },
  { id: "debts", label: "Dívidas", icon: CreditCard },
  { id: "diagnosis", label: "Diagnóstico", icon: Stethoscope },
  { id: "education", label: "Educação", icon: GraduationCap },
  { id: "import", label: "Importar Extrato", icon: Upload },
  { id: "news", label: "Notícias", icon: Newspaper },
];

export default function Sidebar({ active, setActive }) {
  const { user, logout } = useAuth();
  return (
    <aside className="p-4 shrink-0 hidden md:block">
      <div className="hero-navy text-white rounded-3xl h-[calc(100vh-2rem)] w-64 sticky top-4 flex flex-col shadow-xl shadow-primary/20"
        data-testid="sidebar">
        <div className="px-5 pt-7 pb-6 border-b border-white/10 flex flex-col items-center">
          <img src="/alligare-logo-full-white.png" alt="Alligare Consultoria de Recursos Humanos" data-testid="brand-logo"
            className="h-14 w-auto object-contain" />
          <p className="text-[10px] uppercase tracking-[0.18em] text-white/40 mt-3 text-center">Finanças</p>
        </div>

        <nav className="flex-1 p-4 space-y-1.5">
          {items.map((it) => {
            const Icon = it.icon;
            const on = active === it.id;
            return (
              <button key={it.id} data-testid={`nav-${it.id}`} onClick={() => setActive(it.id)}
                className={`w-full flex items-center gap-3 px-4 py-3 rounded-2xl font-body text-sm transition-colors ${
                  on ? "bg-white text-primary font-bold shadow-lg shadow-black/10"
                     : "text-white/70 hover:bg-white/10 hover:text-white"}`}>
                <Icon className="h-[18px] w-[18px]" />
                {it.label}
              </button>
            );
          })}
        </nav>

        <div className="p-4 border-t border-white/10">
          <div className="flex items-center gap-3 px-2 mb-3">
            <div className="h-10 w-10 rounded-full bg-secondary flex items-center justify-center font-heading font-bold text-white shrink-0">
              {(user?.name || user?.email || "U")[0].toUpperCase()}
            </div>
            <div className="min-w-0">
              <p className="text-sm font-body font-medium truncate">{user?.name || "Usuário"}</p>
              <p className="text-xs text-white/50 truncate">{user?.email}</p>
            </div>
          </div>
          <button data-testid="logout-btn" onClick={logout}
            className="w-full flex items-center gap-3 px-4 py-2.5 rounded-2xl text-sm font-body text-white/70 hover:bg-white/10 hover:text-white transition-colors">
            <LogOut className="h-[18px] w-[18px]" /> Sair
          </button>
        </div>
      </div>
    </aside>
  );
}
